module.exports = __webpack_public_path__ + "img/orderbtn.05632625.png";